import { action as apiAction } from 'api/Api'
import {
  add as addNote
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  name: string
  content: any
  index?: number
}

export default (payload: Payload) => async dispatch => {
  const { cardId, name, content, index } = payload

  const tempId = `temp-${new Date().getTime()}`

  const optimisticAction = optimisticDispatch(dispatch, addNote({
    cardId,
    element: {
      id: tempId,
      elementName: '/Data/Note',
      name: name.trim(),
      content,
      isBusy: true,
      index
    }
  }))

  try {
    await apiAction('AddNote', {
      cardId,
      name: name.trim(),
      rtText: content,
      position: index
    })
  } finally {
    optimisticAction.revert()
  }
}
